// extracted by mini-css-extract-plugin
module.exports = {"container":"FreeText_container__T_cA_","content":"FreeText_content__hL_x4"};